export default "__VITE_ASSET__mikkuBfI__"